<template>
    <b-container class="container">
        <br>
        <b-row>
            <b-col cols="3" sm="4" class="d-none d-md-block" v-if="!umbracodata.skjulVenstremenu">
                <leftMenu :menudata="umbracodata.menu" :currentId="umbracodata.id" :sidemenuIndhold="umbracodata.sidemenuIndhold"/>
            </b-col>
            <b-col>
                <h1>{{umbracodata.overskrift}}</h1>
                <img :src="baseUrl + umbracodata.topBanner" v-if="umbracodata.topBanner && umbracodata.topBanner.length>0" />
                <div class="indhold" ref="indhold" v-html="umbracodata.indhold" />

                <b-row v-if='items && items.length>0'>
                    <router-link :to="item.url" tag="a" class="col-6 col-sm-4 col-xl-3 zHover" v-for="item in items" :key="item.id" @click.native="clickTrack(item.id)">
                        <productCard :item="item" />
                    </router-link>
                </b-row>

                <div ref="sidemenuIndhold" class="d-md-none mt-2 text-center" v-html="umbracodata.sidemenuIndhold" />

                <instagramGallery v-if="umbracodata.visInstagramGallery" />

                <div v-if="umbracodata.visFarvekort">
                    <center>
                    <b-input placeholder="Søg efter farve" v-model="searchColor" style="max-width:450px" class="my-3" />
                    </center>
                    <colorPickerContent :pageMode="true" :searchColor="searchColor"/>
                </div>
            </b-col>
        </b-row>
        <br>
    </b-container>
</template>

<script>
import searchService from "../services/searchService.vue";
import { clerkItemToUmItem } from "../services/clerkHelper";
import productCard from "../components/productCard.vue";
import leftMenu from "../components/leftMenu.vue";
let instagramGallery = () => import(/* webpackChunkName: "componentInstagramGallery" */ '../components/instagramGallery.vue');
import colorPickerContent from '../components/colorPickerContent.vue'
export default {
    components:{
        leftMenu,
        instagramGallery,
        colorPickerContent,
        productCard
    },
    computed:{
        baseUrl(){return window.baseUrl;}
    },
    methods:{
        resize(){
            if(!this.$refs.indhold)
                return;
            var allVideos = this.$refs.indhold.querySelectorAll("iframe[src^='https://www.youtube.com'], iframe[src^='https://player.vimeo.com']");
            for(var i=0;i<allVideos.length;i++)
            {
                var aspectRatio = allVideos[i].offsetHeight / allVideos[i].offsetWidth;
                allVideos[i].style.width = "100%";
                allVideos[i].style.height = this.$refs.indhold.offsetWidth * aspectRatio + "px";
            }
            if(!this.$refs.sidemenuIndhold)
                return;
            var allVideosSide = this.$refs.sidemenuIndhold.querySelectorAll("iframe[src^='https://www.youtube.com'], iframe[src^='https://player.vimeo.com']");
            for(var i=0;i<allVideosSide.length;i++)
            {
                var aspectRatio = allVideosSide[i].offsetHeight / allVideosSide[i].offsetWidth;
                allVideosSide[i].style.width = "100%";
                allVideosSide[i].style.height = this.$refs.sidemenuIndhold.offsetWidth * aspectRatio + "px";
            }
        },
        init(){
            //document.title = "Søge resultater";
            // searchService.searchContent(this.query).then((res)=>this.pages = res);
            console.log('clerkItemToUmItem',clerkItemToUmItem);
            if(this.umbracodata.visClearkSearchResults)
                searchService.searchProducts(this.umbracodata.query, false, this.umbracodata.filter).then((res)=>this.items = res.map(clerkItemToUmItem));
        //     var tempRes = {
        //         "status":"ok",
        //         "result":["skv28022","skv81904","skv3629020","skv65855","skv68805","skv65556","skv81903","skv405872","skv63816","skv12508","skv82633","skv62677","skvF15"],
        //         "hits":13,
        //         "count":13,
        //         "facets":null,
        //         "product_data":[
        //             {"categories":[360,2814,11],"id":"skv28022","in_stock":true,"inventory":25,"inventoryRed":0,"list_price":219.95,"name":"Redheads Wilson Gunn Bellum Cabernet Sauv / Shiraz","price":219.95,"shortText":"Endelig er den tilbage - endda i bedste \u00e5rgang hidtil! Lavet af de bedste druer fra Coonawarra & Barossa - fantastisk tung, dyb og vanvittig velsmagende kongevin! ","twelvePrice":149.95,"type":"Product","uoM":"FL 75CL","url":"/redheads-wilson-gunn-bellum-cabernet-sauv-shiraz"},
        //             {"categories":[710,589,2814],"id":"skv81904","in_stock":true,"inventory":50,"inventoryRed":12,"list_price":169.95,"name":"Redheads Studio Blue Belle Semillon ","price":169.95,"shortText":"PARTIVARE - Forf\u00f8rende og charmerende Semillon, med masser af citrus og dejligt balanceret. ","twelvePrice":99.95,"type":"Product","uoM":"FL 75CL","url":"/redheads-studio-blue-belle-semillon"},{"categories":[11,360,2814],"id":"skv3629020","in_stock":true,"inventory":3,"inventoryRed":0,"list_price":329.95,"name":"RedHeads Studio 1888 Shiraz Barossa","price":329.95,"twelvePrice":329.95,"type":"Product","uoM":"FL 75CL","url":"/redheads-studio-1888-shiraz-barossa"},{"categories":[2814],"id":"skv65855","in_stock":true,"inventory":7,"inventoryRed":6,"list_price":369.95,"name":"RedHeads Studio Esul\u00e9 Cabernet McLaren Vale","price":369.95,"shortText":"Sj\u00e6lden frigivelse af TOP vinen Esul\u00e9 fra RedHeads Studio. Blandt de bedste Cabernet Sauvignon og Cabernet Franc blends vi nogensinde har smagt.","twelvePrice":299.95,"type":"Product","uoM":"FL 75CL","url":"/redheads-studio-esul\u00e9-cabernet-mclaren-vale"},{"categories":[11,360,2814],"id":"skv68805","in_stock":false,"inventory":0,"inventoryRed":0,"list_price":259.95,"name":"RedHeads Studio Night of the Living red","price":259.95,"shortText":"RedHeads Night of The Living Red, er et helt unikt blend af Durif, Cabernet Sauvignon og Touriga Nacional, der giver en bl\u00f8d og fyldig r\u00f8dvin, med gode tanniner og en l\u00e6kker moden frugt.","twelvePrice":229.95,"type":"Product","uoM":"FL 75CL","url":"/redheads-studio-night-of-the-living-red"},{"categories":[360,11,2814],"id":"skv65556","in_stock":false,"inventory":0,"inventoryRed":6,"list_price":149.95,"name":"RedHeads Studio The Red Sedan","price":149.95,"shortText":"The Red Sedan er endelig tilbage og st\u00e5r skarpere end nogensinde f\u00f8r - den er klar til at blive din nye favorit fra RedHeads Studio, med overv\u00e6ldende l\u00e6kker frugt og masser af smag..","twelvePrice":99.95,"type":"Product","uoM":"FL 75CL","url":"/redheads-studio-the-red-sedan"},{"categories":[2814],"id":"skv81903","in_stock":false,"inventory":0,"inventoryRed":12,"list_price":179.95,"name":"RedHeads Studio Wilson Gunn Pax ","price":179.95,"shortText":"Frankrig i Australien - klassisk Rhone-blend fra de bedste vinmarker i Barossa Valley. ","twelvePrice":139.95,"type":"Product","uoM":"FL 75CL","url":"/redheads-studio-wilson-gunn-pax"},{"categories":[11,360,2814],"id":"skv405872","in_stock":true,"inventory":42,"inventoryRed":0,"list_price":239.95,"name":"RedHeads Studio March of Progress Shiraz","price":239.95,"twelvePrice":239.95,"type":"Product","uoM":"FL 75CL","url":"/redheads-studio-march-of-progress-shiraz"},{"categories":[6835],"id":"skv63816","in_stock":true,"inventory":14,"inventoryRed":0,"list_price":295.0,"name":"La Curio BUSH VINE Grenache 2011","price":295.0,"shortText":"En kraftig og kompleks r\u00f8dvin skabt af Adam Hooper/RedHeads Studio p\u00e5 den klassiske Chateauneuf du Pape-drue, Grenache.","twelvePrice":295.0,"type":"Product","uoM":"FL 75CL","url":"/la-curio-bush-vine-grenache-2011"},{"categories":[1271,360],"id":"skv12508","in_stock":false,"inventory":0,"inventoryRed":0,"list_price":2369.4,"name":"VALUE #20 - Monster Australien SHIRAZ kasse 12 fl.","price":1184.7,"shortText":"SPAR 50% p\u00e5 12 hamrende l\u00e6kre Shiraz vine. 10 x Australien og 2 x Sydafrika. Intense l\u00e6kre fede bomber med saft og kraft. B\u00f8ffen kalder... ","twelvePrice":2369.4,"type":"Product","uoM":"KS12","url":"/value-20-monster-australien-shiraz-kasse-12-fl"},{"categories":[11,360,1231,2815],"id":"skv82633","in_stock":true,"inventory":95,"inventoryRed":0,"list_price":199.95,"name":"Sew and Sew Sashiko McLaren Vale Shiraz","price":199.95,"shortText":"Saftig Shiraz, med masse af solb\u00e6r, bromb\u00e6r og m\u00f8rke blommer, perfekt til vildt med ribs.","twelvePrice":139.95,"type":"Product","uoM":"FL 75CL","url":"/sew-and-sew-sashiko-mclaren-vale-shiraz"},{"categories":[360,1231,2816],"id":"skv62677","in_stock":false,"inventory":0,"inventoryRed":0,"list_price":299.95,"name":"Pieri Azzardo Shiraz 2014 McLaren Vale","price":299.95,"shortText":"Krafitg med masser af intens frugt. Lavet p\u00e5 t\u00f8rrede Shiraz druer - alts\u00e5 Amarone p\u00e5 SHIRAZ ! - fed l\u00e6kker frugt on intensitet.","twelvePrice":229.95,"type":"Product","uoM":"FL 75CL","url":"/pieri-azzardo-shiraz-2014-mclaren-vale"},
        //             {"categories":[2826,11,570],"id":"skvF15","in_stock":true,"inventory":11462,"inventoryRed":240,"list_price":169.95,"name":"FULL 15 by Kamnik - The Balkan Power Duo 15%","price":169.95,"shortText":"Helt igennem imponerende vanvittig kvalitet og smagsoplevelse - denne vin sl\u00e5r alt andet vi har, hvis du er til intensitet og elegance i samme flaske.","twelvePrice":75.0,"type":"Product","uoM":"FL 75CL","url":"/full-15-by-kamnik-the-balkan-power-duo-15"}]}
        //     this.items = tempRes.product_data.map(clerkItemToUmItem);
        }
    },
    props: ["umbracodata"],
    data(){
        return {
            searchColor : "",
            urlPrefix : "",
            items : [],
        }
    },
    created: function() {
        window.addEventListener('resize',this.resize);
        this.$nextTick(()=>this.resize());
    },
    destroyed: function() {
        window.removeEventListener('resize', this.resize);
    },
    mounted(){
        if (window["Clerk"])
            this.init();
        window.addEventListener("ClerkLoaded", this.init);
        this.urlPrefix = location.origin;
    }
};
</script>

<style lang="scss" scoped>
    .container{
        padding-top:40px;
        /deep/ .allColorsRow{
            @media only screen and (min-width: 768px) {
                max-height:417px !important;
            }
            @media only screen and (min-width: 992px) {
                max-height:550px !important;
            }
            @media only screen and (min-width: 1200px) {
                max-height:644px !important;
            }
        }
    }
    img{
        max-width:100%;
    }
    h1{
        font-size:1.4rem;
    }
    .indhold /deep/ {
        line-height:22px;
        h2{
            font-size:1.125rem;
        }
        h3{
            font-size:0.96rem;
        }
    }
</style>
